import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

import { APPLICATION_INSIGHT_CONNECTION_STRING } from './config/config'
import { getGitTag } from './version'

export const reactPlugin = new ReactPlugin()
const appInsights = new ApplicationInsights({
  config: {
    connectionString: APPLICATION_INSIGHT_CONNECTION_STRING,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  },
})

appInsights.loadAppInsights()

// Add git tag to all telemetry
const gitTag = getGitTag()
if (gitTag) {
  appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags || {}
    envelope.tags['ai.application.ver'] = gitTag
  })
}

export default appInsights
